import WPMDBGlobals from './helpers/wpmdbGlobals';
import {jQueryAjaxError} from 'src/wp-migrate-db-pro/asset/src/js/helpers/utils';
const globals = new WPMDBGlobals();
const wpmdb = window.wpmdb || {};

(function( $, wpmdb ) {

	wpmdb.migration_progress_controller = require( './modules/MigrationProgress-controller' );
	wpmdb.current_migration = null;
	wpmdb.migration_selection = wpmdb.functions.wpmdb_migration_type();

	window.onbeforeunload = function( e ) {
		if ( 'import' === wpmdb.functions.wpmdb_migration_type() && !$( '.step-two' ).is( ':visible' ) ) {
			wpmdb.functions.remove_localStorage_form_data();
		}

		if ( globals.currently_migrating ) {
			e = e || window.event;

			// For IE and Firefox prior to version 4
			if ( e ) {
				e.returnValue = wpmdb_strings.sure;
			}

			// For Safari
			return wpmdb_strings.sure;
		}
	};

	wpmdb.functions.exclude_post_types_warning = function() {
		var excluded_post_types = $( '#select-post-types' ).val();
		var excluded_post_types_text = '';
		var $exclude_post_types_warning = $( '.exclude-post-types-warning' );

		if ( excluded_post_types ) {
			excluded_post_types_text = '<code>' + excluded_post_types.join( '</code>, <code>' ) + '</code>';
			$( '.excluded-post-types' ).html( excluded_post_types_text );

			if ( '0' === $exclude_post_types_warning.css( 'opacity' ) ) {
				$exclude_post_types_warning
					.css( { opacity: 0 } )
					.slideDown( 200 )
					.animate( { opacity: 1 } );
			}
		} else {
			$exclude_post_types_warning
				.css( { opacity: 0 } )
				.slideUp( 200 )
				.animate( { opacity: 0 } );
		}
	};

	//Main method that shows migration progress in the UI
	wpmdb.functions.migrate_table_recursive = function( current_row, primary_keys, iterator ) {
		let i = iterator || 0;

		if ( i >= globals.tables_to_migrate.length ) {

			if ( 'upload' === globals.stage && wpmdb.current_migration.model.getStageItems( 'find_replace' ).length ) {
				globals.stage = 'find_replace';
				globals.tables_to_migrate = wpmdb.current_migration.model.getStageItems( 'find_replace', 'name' );
				globals.tables_to_migrate = globals.tables_to_migrate.map( function( table ) {
					return '_mig_' + table;
				} );
				i = 0;
			} else if ( 'backup' === globals.stage ) {

				if ( -1 !== $.inArray( globals.migration_intent, [ 'push', 'pull' ] ) ) {
					globals.stage = 'migrate';
				} else if ( 'import' === globals.migration_intent ) {
					globals.stage = 'upload';
				} else {
					globals.stage = globals.migration_intent;
				}

				wpmdb.current_migration.model.setActiveStage( globals.stage );

				if ( 'find_replace' !== globals.stage && 'migrate' !== globals.stage ) {
					wpmdb.functions.wpmdb_call_next_hook();
					return;
				}

				i = 0;

				// should get from model
				globals.tables_to_migrate = wpmdb.functions.get_tables_to_migrate( null, null );

			} else {
				$( '.progress-label' ).removeClass( 'label-visible' );
				wpmdb.common.hooks = $.wpmdb.apply_filters( 'wpmdb_before_migration_complete_hooks', wpmdb.common.hooks );
				wpmdb.common.hooks.push( wpmdb.functions.migration_complete );
				wpmdb.common.hooks.push( wpmdb.functions.wpmdb_flush );
				wpmdb.common.hooks = $.wpmdb.apply_filters( 'wpmdb_after_migration_complete_hooks', wpmdb.common.hooks );
				wpmdb.common.hooks.push( wpmdb.functions.migration_complete_events );
				wpmdb.common.next_step_in_migration = { fn: wpmdb.functions.wpmdb_call_next_hook };
				wpmdb.functions.execute_next_step();
				return;
			}
		}

		var last_table = 0;
		if ( i === ( globals.tables_to_migrate.length - 1 ) ) {
			last_table = 1;
		}

		var gzip = 0;
		if ( -1 !== $.inArray( globals.migration_intent, [
				'push',
				'pull'
			] ) && 1 === parseInt( wpmdb.common.connection_data.gzip ) ) {
			gzip = 1;
		}

		var request_data = {
			action: 'wpmdb_migrate_table',
			migration_state_id: wpmdb.migration_state_id,
			table: globals.tables_to_migrate[ i ],
			stage: globals.stage,
			current_row: current_row,
			last_table: last_table,
			primary_keys: primary_keys,
			gzip: gzip,
			nonce: wpmdb_data.nonces.migrate_table
		};

		if ( -1 !== $.inArray( globals.migration_intent, [ 'push', 'pull' ] ) ) {
			request_data.bottleneck = wpmdb.common.connection_data.bottleneck;
			request_data.prefix = wpmdb.common.connection_data.prefix;
		}

		if ( wpmdb.common.connection_data && wpmdb.common.connection_data.path_current_site && wpmdb.common.connection_data.domain ) {
			request_data.path_current_site = wpmdb.common.connection_data.path_current_site;
			request_data.domain_current_site = wpmdb.common.connection_data.domain;
		}

		globals.doing_ajax = true;

		$.ajax( {
			url: ajaxurl,
			type: 'POST',
			dataType: 'text',
			cache: false,
			timeout: 0,
			data: request_data,
			error: function( jqXHR, textStatus, errorThrown ) {
				var progress_text = wpmdb_strings.table_process_problem + ' ' + globals.tables_to_migrate[ i ] + '<br /><br />' + wpmdb_strings.status + ': ' + jqXHR.status + ' ' + jqXHR.statusText + '<br /><br />' + wpmdb_strings.response + ':<br />' + jqXHR.responseText;
				wpmdb.current_migration.setState( wpmdb_strings.migration_failed, progress_text, 'error' );

				globals.doing_ajax = false;
				console.log( jqXHR );
				console.log( textStatus );
				console.log( errorThrown );
				wpmdb.common.migration_error = true;
				wpmdb.functions.migration_complete_events();

			},
			success: function( data ) {
				globals.doing_ajax = false;
				data = $.trim( data );
				var row_information = wpmdb.functions.wpmdb_parse_json( data );
				var error_text = '';

				if ( false === row_information || null === row_information ) {

					// should update model
					if ( '' === data || null === data ) {
						error_text = wpmdb_strings.table_process_problem_empty_response + ' ' + globals.tables_to_migrate[ i ];
					} else {
						error_text = globals.get_ajax_errors( data, null, null );
					}

					wpmdb.current_migration.setState( wpmdb_strings.migration_failed, error_text, 'error' );
					wpmdb.common.migration_error = true;
					wpmdb.functions.migration_complete_events();
					return;
				}

				if ( 'undefined' !== typeof row_information.wpmdb_error && 1 === row_information.wpmdb_error ) {
					wpmdb.current_migration.setState( wpmdb_strings.migration_failed, row_information.body, 'error' );
					wpmdb.common.migration_error = true;
					wpmdb.functions.migration_complete_events();
					return;
				}

				var item_name = globals.tables_to_migrate[ i ];
				if ( 'import' === globals.migration_intent  && 'find_replace' === globals.stage ) {
					item_name = item_name.replace( wpmdb_data.this_temp_prefix, '' );
				}

				//successful iteration
				wpmdb.current_migration.setText();
				wpmdb.current_migration.model.getStageModel( globals.stage ).setItemRowsTransferred( item_name, row_information.current_row );

				// We need the returned file name for delivery or display to the user.
				if ( 1 === last_table && 'savefile' === globals.migration_intent ) {
					if ( 'undefined' !== typeof row_information.dump_filename ) {
						globals.dump_filename = row_information.dump_filename;
					}
					if ( 'undefined' !== typeof row_information.dump_path ) {
						globals.dump_path = row_information.dump_path;
					}
				}

				if ( -1 === parseInt( row_information.current_row ) ) {
					i++;
					row_information.current_row = '';
					row_information.primary_keys = '';
				}

				wpmdb.common.next_step_in_migration = {
					fn: wpmdb.functions.migrate_table_recursive,
					args: [ row_information.current_row, row_information.primary_keys, i ]
				};
				wpmdb.functions.execute_next_step();
			}
		} );

	};

	wpmdb.functions.migration_complete_events = function() {
		if ( false === wpmdb.common.migration_error ) {
			if ( '' === wpmdb.common.non_fatal_errors ) {
				if ( 'savefile' !== globals.migration_intent && true === $( '#save_computer' ).is( ':checked' ) ) {
					wpmdb.current_migration.setText();
				}

				globals.completed_msg = globals.completed_msg + '&nbsp;<div class="dashicons dashicons-yes"></div>';

				if ( true === globals.migration_cancelled ) {
					var cancel_success = wpmdb_strings.migration_cancelled_success;

					if ( 'find_replace' === globals.migration_intent ) {
						cancel_success = wpmdb_strings.find_replace_cancelled_success;
					}

					wpmdb.current_migration.setState( globals.completed_msg, cancel_success, 'cancelled' );
				} else {
					wpmdb.current_migration.setState( globals.completed_msg, '', 'complete' );
				}

			} else {
				wpmdb.current_migration.setState( wpmdb_strings.completed_with_some_errors, wpmdb.common.non_fatal_errors, 'error' );
			}
		}

		$( '.migration-controls' ).addClass( 'hidden' );

		// reset migration variables so consecutive migrations work correctly
		wpmdb.common.hooks = [];
		wpmdb.common.call_stack = [];
		wpmdb.common.migration_error = false;
		globals.currently_migrating = false;
		globals.migration_completed = true;
		globals.migration_paused = false;
		globals.migration_cancelled = false;
		globals.doing_ajax = false;
		wpmdb.common.non_fatal_errors = '';
		globals.tables_to_migrate = [];

		$( '.progress-label' ).remove();
		$( '.migration-progress-ajax-spinner' ).remove();
		$( '.close-progress-content' ).show();
		$( '#overlay' ).css( 'cursor', 'pointer' );
		wpmdb.current_migration.model.setMigrationComplete();
	};

	wpmdb.functions.migration_complete = function() {

		$( '.migration-controls' ).addClass( 'hidden' );

		if ( 'savefile' === globals.migration_intent ) {
			globals.currently_migrating = false;
			var migrate_complete_text = wpmdb_strings.migration_complete;
			if ( $( '#save_computer' ).is( ':checked' ) ) {
				var url = wpmdb_data.this_download_url + encodeURIComponent( globals.dump_filename );
				if ( $( '#gzip_file' ).is( ':checked' ) ) {
					url += '&gzip=1';
				}
				// Event to hook on to when Migration is completely finished
				$('body').trigger( 'wpmdb_done' );
				window.location = url;
			} else {
				// Event to hook on to when Migration is completely finished
				$('body').trigger( 'wpmdb_done' );
				migrate_complete_text = wpmdb_strings.completed_dump_located_at + ' ' + globals.dump_path;
			}

			if ( false === wpmdb.common.migration_error ) {

				wpmdb.functions.migration_complete_events();
				wpmdb.current_migration.setState( globals.completed_msg, migrate_complete_text, 'complete' );

			}

		} else { // rename temp tables, delete old tables

			wpmdb.current_migration.setState( null, wpmdb_strings.finalizing_migration, 'finalizing' );

			var request_data = {
				action: 'wpmdb_finalize_migration',
				migration_state_id: wpmdb.migration_state_id,
				tables: globals.tables_to_migrate.join( ',' ),
				nonce: wpmdb_data.nonces.finalize_migration
			};

			if ( -1 !== $.inArray( globals.migration_intent, [ 'push', 'pull' ] ) ) {
				request_data.prefix = wpmdb.common.connection_data.prefix;
			}

			globals.doing_ajax = true;
			$.ajax( {
				url: ajaxurl,
				type: 'POST',
				dataType: 'json',
				cache: false,
				data: request_data,
				error: function( jqXHR ) {
					globals.doing_ajax = false;
					let responseText = wpmdb_strings.finalize_tables_problem;
					jQueryAjaxError( responseText, jqXHR );
				},
				success: function( data ) {
					globals.doing_ajax = false;
					if ( 'undefined' !== typeof data && 'undefined' !== typeof data.wpmdb_error && 1 === data.wpmdb_error ) {
						wpmdb.common.migration_error = true;
						wpmdb.functions.migration_complete_events();
						wpmdb.current_migration.setState( wpmdb_strings.migration_failed, data.body, 'error' );

						return;
					}
					wpmdb.common.next_step_in_migration = { fn: wpmdb.functions.wpmdb_call_next_hook };
					wpmdb.functions.execute_next_step();
				}
			} );
		}
	};

	wpmdb.functions.wpmdb_flush = function() {
		if ( 'savefile' !== globals.migration_intent ) {
			wpmdb.current_migration.setText( wpmdb_strings.flushing );
			globals.doing_ajax = true;
			$.ajax( {
				url: ajaxurl,
				type: 'POST',
				dataType: 'text',
				cache: false,
				data: {
					action: 'wpmdb_flush',
					migration_state_id: wpmdb.migration_state_id,
					nonce: wpmdb_data.nonces.flush
				},
				error: function( jqXHR, textStatus, errorThrown ) {
					globals.doing_ajax = false;
					wpmdb.current_migration.setState( wpmdb_strings.migration_failed, wpmdb_strings.flush_problem, 'error' );

					alert( jqXHR + ' : ' + textStatus + ' : ' + errorThrown );
					wpmdb.common.migration_error = true;
					wpmdb.functions.migration_complete_events();

				},
				success: function( data ) {
					globals.doing_ajax = false;
					if ( '1' !== $.trim( data ) ) {
						wpmdb.current_migration.setState( wpmdb_strings.migration_failed, data, 'error' );

						wpmdb.common.migration_error = true;
						wpmdb.functions.migration_complete_events();
						return;
					}

					// Event to hook on to when Migration is completely finished
					$('body').trigger( 'wpmdb_done' );
					wpmdb.common.next_step_in_migration = { fn: wpmdb.functions.wpmdb_call_next_hook };
					wpmdb.functions.execute_next_step();
				}
			} );
		}
	};

	wpmdb.functions.execute_next_step = function( instance = null, run_fn = true ) {

		// if delay is set, set a timeout for delay to recall this function, then return
		if ( 0 < globals.delay_between_requests && false === globals.flag_skip_delay ) {
			setTimeout( function() {
				globals.flag_skip_delay = true;
				wpmdb.functions.execute_next_step( instance );
			}, globals.delay_between_requests );
			return;
		} else {
			globals.flag_skip_delay = false;
		}

		if ( true === globals.migration_paused ) {
			$( '.migration-progress-ajax-spinner' ).hide();

			// Pause the timer
			wpmdb.current_migration.pauseTimer();

			var pause_text = '';
			if ( true === globals.is_auto_pause_before_finalize ) {
				pause_text = wpmdb_strings.paused_before_finalize;
				globals.is_auto_pause_before_finalize = false;

				if ( 'find_replace' === wpmdb.functions.wpmdb_migration_type() ) {
					pause_text = wpmdb_strings.find_replace_paused_before_finalize;
				}
			} else {
				pause_text = wpmdb_strings.paused;
			}

			wpmdb.current_migration.setState( null, pause_text, 'paused' );

			// Re-bind Pause/Resume button to Resume when we are finally Paused
			$( 'body' ).on( 'click', '.pause-resume', function( event ) {
				globals.set_pause_resume_button( event, instance );
			} );
			$( 'body' ).on( 'click', '.cancel', function( event ) {
				globals.cancel_migration( event );
			} );
			$( '.pause-resume' ).html( wpmdb_strings.resume );

		} else if ( true === globals.migration_cancelled ) {
			globals.migration_intent = wpmdb.functions.wpmdb_migration_type();

			var progress_msg;

			if ( 'savefile' === globals.migration_intent ) {
				progress_msg = wpmdb_strings.removing_local_sql;
			} else if ( 'pull' === globals.migration_intent ) {
				if ( 'backup' === globals.stage ) {
					progress_msg = wpmdb_strings.removing_local_backup;
				} else {
					progress_msg = wpmdb_strings.removing_local_temp_tables;
				}
			} else if ( 'push' === globals.migration_intent ) {
				if ( 'backup' === globals.stage ) {
					progress_msg = wpmdb_strings.removing_remote_sql;
				} else {
					progress_msg = wpmdb_strings.removing_remote_temp_tables;
				}
			}
			wpmdb.current_migration.setText( progress_msg );

			var request_data = {
				action: 'wpmdb_cancel_migration',
				migration_state_id: wpmdb.migration_state_id,
				nonce: wpmdb_data.nonces.cancel_migration
			};

			globals.doing_ajax = true;

			$.ajax( {
				url: ajaxurl,
				type: 'POST',
				dataType: 'text',
				cache: false,
				data: request_data,
				error: function( jqXHR, textStatus, errorThrown ) {
					wpmdb.current_migration.setState( wpmdb_strings.migration_cancellation_failed, wpmdb_strings.manually_remove_temp_files + '<br /><br />' + wpmdb_strings.status + ': ' + jqXHR.status + ' ' + jqXHR.statusText + '<br /><br />' + wpmdb_strings.response + ':<br />' + jqXHR.responseText, 'error' );
					console.log( jqXHR );
					console.log( textStatus );
					console.log( errorThrown );
					globals.doing_ajax = false;
					wpmdb.common.migration_error = true;
					wpmdb.functions.migration_complete_events();

				},
				success: function( data ) {
					globals.doing_ajax = false;
					data = $.trim( data );

					if ( ( 'push' === globals.migration_intent && '1' !== data ) || ( 'push' !== globals.migration_intent && '' !== data ) ) {

						if ( 'undefined' !== typeof data && 'undefined' !== typeof data.wpmdb_error && 1 === data.wpmdb_error ) {
							data = data.wpmdb_error;
						}

						wpmdb.current_migration.setState( wpmdb_strings.migration_cancellation_failed, data, 'error' );
						wpmdb.common.migration_error = true;
						wpmdb.functions.migration_complete_events();
						return;
					}

					globals.completed_msg = wpmdb_strings.migration_cancelled;

					if ( 'find_replace' === globals.migration_intent ) {
						globals.completed_msg = wpmdb_strings.find_replace_cancelled;
					}

					wpmdb.functions.migration_complete_events();
					wpmdb.current_migration.setStatus( 'cancelled' );
				}
			} );
		} else {
			if(run_fn){
				wpmdb.common.next_step_in_migration.fn.apply( instance, wpmdb.common.next_step_in_migration.args );
			}

		}
	};

	wpmdb.functions.maybe_show_prefix_notice = ( prefix ) => {
		var $prefix_notice = $( '.prefix-notice' );

		$prefix_notice.hide();

		if ( prefix !== wpmdb_data.this_prefix ) {
			$( '.remote-prefix' ).html( prefix );
			globals.show_prefix_notice = true;
			$prefix_notice.show();
		}
	};

	wpmdb.functions.maybe_show_mst_warning = function( data ) {
		const migration_type = wpmdb.functions.wpmdb_migration_type();
		let show_mst_warning = false;

		if ( -1 !== $.inArray( migration_type, [ 'push', 'pull' ] ) && 'undefined' !== typeof data.site_details ) {
			if ( wpmdb_data.site_details.is_multisite !== data.site_details.is_multisite ) {
				if ( 'undefined' === typeof wpmdb.mst || 'undefined' === typeof data.mst_available || '1' !== data.mst_available ) {
					show_mst_warning = true;
				}
			}
		} else if ( 'import' === migration_type ) {
			if ( 'undefined' !== typeof data.multisite && 'undefined' !== typeof data.subsite_export ) {
				if (
					( 'false' === wpmdb_data.site_details.is_multisite && 'true' === data.multisite && 'true' !== data.subsite_export ) ||
					( 'true' === wpmdb_data.site_details.is_multisite && 'false' === data.multisite )
				) {
					show_mst_warning = true;
				}
			}
		}

		show_mst_warning = $.wpmdb.apply_filters( 'wpmdb_show_mst_warning', show_mst_warning );

		if ( show_mst_warning ) {
			$( '.mst-required' ).show();
		}

		return show_mst_warning;

	};

	wpmdb.functions.maybe_show_select_table_notice = function() {

		// check that they've selected some tables to migrate
		if ( $( '#migrate-selected' ).is( ':checked' ) && null === $( '#select-tables' ).val() ) {
			if ( 'import' !== wpmdb.functions.wpmdb_migration_type() ) {
				alert( wpmdb_strings.please_select_one_table );
				return true;
			} else {
				if ( $( '#import-find-replace' ).is( ':checked' ) && $( '#select-tables' ).is( ':visible' ) ) {
					alert( wpmdb_strings.please_select_one_table_import );
					return true;
				}
			}
		}

		// check that they've selected some tables to backup
		if ( 'savefile' !== wpmdb.functions.wpmdb_migration_type() && $( '#backup-manual-select' ).is( ':checked' ) && null === $( '#select-backup' ).val() ) {
			alert( wpmdb_strings.please_select_one_table_backup );
			return true;
		}

		return false;
	};

	wpmdb.functions.remove_protocol = function( url ) {
		return url.replace( /^https?:/i, '' );
	};

	wpmdb.functions.create_table_select = function( tables, table_sizes_hr, selected_tables ) {
		var $table_select = document.createElement( 'select' );
		$( $table_select ).attr( {
			multiple: 'multiple',
			name: 'select_tables[]',
			id: 'select-tables',
			class: 'multiselect'
		} );

		if ( 0 < tables.length ) {
			$.each( tables, function( index, table ) {
				if ( $.wpmdb.apply_filters( 'wpmdb_exclude_table', false, table ) ) {
					return;
				}

				var selected = ' ';
				if ( undefined !== selected_tables && null !== selected_tables && 0 < selected_tables.length && -1 !== $.inArray( table, selected_tables ) ) {
					selected = ' selected="selected" ';
				}

				var size = '';
				if ( 0 !== table_sizes_hr.length ) {
					size = ' (' + table_sizes_hr[ table ] + ')';
				}

				$( $table_select ).append( '<option' + selected + 'value="' + table + '">' + table + size + '</option>' );
			} );
		}

		return $table_select;
	};

	/**
	 * Returns tables selected for migration.
	 *
	 * @returns {array}
	 *
	 * Also handler for wpmdb_get_tables_to_migrate filter, disregards input values as it is the primary source.
	 */
	wpmdb.functions.get_tables_to_migrate = function() {
		var tables = [];
		var mig_type = wpmdb.functions.wpmdb_migration_type();
		var table_intent = $( 'input[name=table_migrate_option]:checked' ).val();

		// Grab tables as per what the user has selected from the multiselect box or all prefixed tables.
		if ( 'migrate_select' === table_intent ) {
			tables = $( '#select-tables' ).val();
		} else {
			if ( 'pull' !== mig_type && 'undefined' !== typeof wpmdb_data.this_prefixed_tables ) {
				tables = wpmdb_data.this_prefixed_tables;
			} else if ( 'pull' === mig_type && 'undefined' !== typeof wpmdb.common.connection_data && 'undefined' !== typeof wpmdb.common.connection_data.prefixed_tables ) {
				tables = wpmdb.common.connection_data.prefixed_tables;
			}
		}

		return tables;
	};

	wpmdb.functions.update_migrate_button_text = function() {
		var migration_intent = wpmdb.functions.wpmdb_migration_type();
		var save_string = ( $( '#save-migration-profile' ).is( ':checked' ) ) ? '_save' : '';
		var migrate_string = 'migrate_button_' + ( ( 'savefile' === migration_intent ) ? 'export' : migration_intent ) + save_string;
		$( '.migrate-db .button-primary' ).val( wpmdb_strings[ migrate_string ] );
	};

	// fired when the connection info box changes (e.g. gets pasted into)
	wpmdb.functions.connection_box_changed = function() {
		var $this = $( '.pull-push-connection-info' );

		if ( -1 === $.inArray( wpmdb.functions.wpmdb_migration_type(), [ 'push', 'pull' ] ) ||
		     ( globals.doing_ajax || $( $this ).hasClass( 'temp-disabled' ) ) && false === wpmdb.force_reconnect ) {
			return;
		}

		wpmdb.force_reconnect = false;
		var data = $( '.pull-push-connection-info' ).val();

		var connection_info = $.trim( data ).split( '\n' );
		var error = false;
		var error_message = '';

		if ( '' === connection_info ) {
			error = true;
			error_message = wpmdb_strings.connection_info_missing;
		}

		// attempt to format the connection info from a single line
		if ( 1 === connection_info.length && !error ) {
			var connection_words = $.trim( data ).split( ' ' );
			if ( 2 === connection_words.length ) {
				connection_info = connection_words;
			}
		}

		if ( 2 !== connection_info.length && !error ) {
			error = true;
			error_message = wpmdb_strings.connection_info_incorrect;
		}

		if ( !error && !globals.validate_url( connection_info[ 0 ] ) ) {
			error = true;
			error_message = wpmdb_strings.connection_info_url_invalid;
		}

		var key_length = 0;

		if ( 'undefined' !== typeof connection_info[ 1 ] ) {
			key_length = connection_info[ 1 ].length;
		}

		if ( !error && 32 !== key_length && 40 !== key_length ) {
			error = true;
			error_message = wpmdb_strings.connection_info_key_invalid;
		}

		if ( !error && connection_info[ 0 ] === wpmdb_data.connection_info[ 0 ] ) {
			error = true;
			error_message = wpmdb_strings.connection_info_local_url;
		}

		if ( !error && connection_info[ 1 ] === wpmdb_data.connection_info[ 1 ] ) {
			error = true;
			error_message = wpmdb_strings.connection_info_local_key;
		}
		if ( error ) {
			$( '.connection-status' ).html( error_message );
			$( '.connection-status' ).addClass( 'notification-message error-notice migration-error' );
			return;
		}

		var new_connection_info_contents = connection_info[ 0 ] + '\n' + connection_info[ 1 ];

		// If connection info is a single line
		if ( 1 === $.trim( data ).split( '\n' ).length ) {

			// Repopulate the input with the info on two lines
			$( '.pull-push-connection-info' ).val( new_connection_info_contents );
		}

		if ( false === wpmdb_data.openssl_available ) {
			connection_info[ 0 ] = connection_info[ 0 ].replace( 'https://', 'http://' );
			new_connection_info_contents = connection_info[ 0 ] + '\n' + connection_info[ 1 ];
			$( '.pull-push-connection-info' ).val( new_connection_info_contents );
		}

		globals.show_prefix_notice = false;
		globals.doing_ajax = true;
		globals.disable_export_type_controls();

		if ( $( '.basic-access-auth-wrapper' ).is( ':visible' ) ) {
			connection_info[ 0 ] = connection_info[ 0 ].replace( /\/\/(.*)@/, '//' );
			connection_info[ 0 ] = connection_info[ 0 ].replace( '//', '//' + encodeURIComponent( $.trim( $( '.auth-username' ).val() ) ) + ':' + encodeURIComponent( $.trim( $( '.auth-password' ).val() ) ) + '@' );
			new_connection_info_contents = connection_info[ 0 ] + '\n' + connection_info[ 1 ];
			$( '.pull-push-connection-info' ).val( new_connection_info_contents );
			$( '.basic-access-auth-wrapper' ).hide();
		}

		$( '.step-two' ).hide();
		$( '.ssl-notice' ).hide();
		$( '.prefix-notice' ).hide();
		$( '.connection-status' ).show();

		$( '.connection-status' ).html( wpmdb_strings.establishing_remote_connection );
		$( '.connection-status' ).removeClass( 'notification-message error-notice migration-error' );
		$( '.connection-status' ).append( globals.ajax_spinner );

		var intent = wpmdb.functions.wpmdb_migration_type();

		globals.profile_name_edited = false;

		return $.ajax( {
			url: ajaxurl,
			type: 'POST',
			dataType: 'json',
			cache: false,
			data: {
				action: 'wpmdb_verify_connection_to_remote_site',
				url: connection_info[ 0 ],
				key: connection_info[ 1 ],
				intent: intent,
				nonce: wpmdb_data.nonces.verify_connection_to_remote_site
			},
			error: function( jqXHR, textStatus, errorThrown ) {
				$( '.connection-status' ).html( globals.get_ajax_errors( jqXHR.responseText, '(#100)', jqXHR ) );
				$( '.connection-status' ).addClass( 'notification-message error-notice migration-error' );
				$( '.ajax-spinner' ).remove();
				globals.doing_ajax = false;
				globals.enable_export_type_controls();
			},
			success: function( data ) {
				$( '.ajax-spinner' ).remove();
				globals.doing_ajax = false;
				globals.enable_export_type_controls();

				if ( 'undefined' !== typeof data.wpmdb_error && 1 === data.wpmdb_error ) {
					$( '.connection-status' ).html( data.body );
					$( '.connection-status' ).addClass( 'notification-message error-notice migration-error' );

					if ( data.body.indexOf( '401 Unauthorized' ) > -1 ) {
						$( '.basic-access-auth-wrapper' ).show();
					}

					if ( !$( '.pull-push-connection-info' ).hasClass( 'temp-disabled' ) && !$( '.connect-button' ).is( ':visible' ) ) {
						$( '.pull-push-connection-info' ).removeAttr( 'readonly' );
						$( '.connect-button' ).show();
					}

					return;
				}

				if ( true === wpmdb.functions.maybe_show_mst_warning( data ) ) {
					$( '.connection-status' ).hide();
					return;
				}

				globals.maybe_show_ssl_warning( connection_info[ 0 ], connection_info[ 1 ], data.scheme );

				var profile_name = globals.get_domain_name( data.url );
				$( '.create-new-profile' ).val( profile_name );

				$( '.pull-push-connection-info' ).addClass( 'temp-disabled' );
				$( '.pull-push-connection-info' ).attr( 'readonly', 'readonly' );
				$( '.connect-button' ).hide();

				$( '.connection-status' ).hide();
				$( '.step-two' ).show();

				wpmdb.functions.maybe_show_prefix_notice( data.prefix );

				globals.connection_established = true;
				globals.set_connection_data( data );
				globals.move_connection_info_box();
				globals.change_replace_values();

				globals.maybe_show_mixed_cased_table_name_warning();

				globals.refresh_table_selects(null, null, this);

				globals.$push_select_backup = $( globals.$pull_select ).clone();
				$( globals.$push_select_backup ).attr( {
					name: 'select_backup[]',
					id: 'select-backup'
				} );

				var $post_type_select = document.createElement( 'select' );
				$( $post_type_select ).attr( {
					multiple: 'multiple',
					name: 'select_post_types[]',
					id: 'select-post-types',
					class: 'multiselect'
				} );

				$.each( wpmdb.common.connection_data.post_types, function( index, value ) {
					$( $post_type_select ).append( '<option value="' + value + '">' + value + '</option>' );
				} );

				globals.$pull_post_type_select = $post_type_select;

				$( '#new-path-missing-warning, #new-url-missing-warning' ).hide();

				if ( 'pull' === wpmdb.functions.wpmdb_migration_type() ) {
					$( '#new-url' ).val( wpmdb.functions.remove_protocol( wpmdb_data.this_url ) );
					$( '#new-path' ).val( wpmdb_data.this_path );
					if ( 'true' === wpmdb_data.is_multisite ) {
						$( '#new-domain' ).val( wpmdb_data.this_domain );
						$( '.replace-row.pin .old-replace-col input[type="text"]' ).val( wpmdb.functions.remove_protocol( data.url ) );
					}
					$( '#old-url' ).val( wpmdb.functions.remove_protocol( data.url ) );
					$( '#old-path' ).val( data.path );

					$.wpmdb.do_action( 'wpmdb_update_pull_table_select' );
					$( '#select-post-types' ).remove();
					$( '.exclude-post-types-warning' ).after( globals.$pull_post_type_select );
					wpmdb.functions.exclude_post_types_warning();
					$( '.table-prefix' ).html( data.prefix );
					$( '.backup-table-prefix' ).html( wpmdb_data.site_details.prefix );
					$( '.uploads-dir' ).html( wpmdb_data.this_uploads_dir );
				} else {
					$( '#new-url' ).val( wpmdb.functions.remove_protocol( data.url ) );
					$( '#new-path' ).val( data.path );

					if ( 'true' === wpmdb_data.is_multisite ) {
						$( '.replace-row.pin .old-replace-col input[type="text"]' ).val( wpmdb.functions.remove_protocol( wpmdb_data.this_url ) );
					}
					$.wpmdb.do_action( 'wpmdb_update_push_table_select' );
					$( '#select-backup' ).remove();
					$( '.backup-tables-wrap' ).prepend( globals.$push_select_backup );
				}

				$('body').trigger( 'wpmdb_connection_fired' );

				wpmdb.common.next_step_in_migration = {
					fn: $.wpmdb.do_action,
					args: [ 'verify_connection_to_remote_site', wpmdb.common.connection_data ]
				};
				wpmdb.functions.execute_next_step();
			}

		} );

	};

	/**
	 *
	 * ========= DOM ready =========
	 *
	 * Mostly direct DOM manipulation specific code
	 *
	 */
	$( document ).ready( function() {
		wpmdb.migration_state_id = '';

		$( '#plugin-compatibility' ).change( function( e ) {
			var install = '1';
			var $status = $( this ).closest( 'td' ).next( 'td' ).find( '.setting-status' );

			if ( !$( this ).is( ':checked' ) ) {
				install = '0';
			}

			$( '.plugin-compatibility-wrap' ).toggle();

			$status.find( '.ajax-success-msg' ).remove();
			$status.append( globals.ajax_spinner );
			$( '#plugin-compatibility' ).attr( 'disabled', 'disabled' );
			$( '.plugin-compatibility' ).addClass( 'disabled' );

			$.ajax( {
				url: ajaxurl,
				type: 'POST',
				dataType: 'text',
				cache: false,
				data: {
					action: 'wpmdb_plugin_compatibility',
					install: install,
					nonce: wpmdb_data.nonces.plugin_compatibility
				},
				error: function( jqXHR, textStatus, errorThrown ) {
					alert( wpmdb_strings.plugin_compatibility_settings_problem + '\r\n\r\n' + wpmdb_strings.status + ' ' + jqXHR.status + ' ' + jqXHR.statusText + '\r\n\r\n' + wpmdb_strings.response + '\r\n' + jqXHR.responseText );
					$( '.ajax-spinner' ).remove();
					$( '#plugin-compatibility' ).removeAttr( 'disabled' );
					$( '.plugin-compatibility' ).removeClass( 'disabled' );
				},
				success: function( data ) {
					if ( '' !== $.trim( data ) ) {
						alert( data );
					} else {
						$status.append( '<span class="ajax-success-msg">' + wpmdb_strings.saved + '</span>' );
						$( '.ajax-success-msg' ).fadeOut( 2000, function() {
							$( this ).remove();
						} );
					}
					$( '.ajax-spinner' ).remove();
					$( '#plugin-compatibility' ).removeAttr( 'disabled' );
					$( '.plugin-compatibility' ).removeClass( 'disabled' );
				}
			} );

		} );

		if ( $( '#plugin-compatibility' ).is( ':checked' ) ) {
			$( '.plugin-compatibility-wrap' ).show();
		}

		if ( 0 <= navigator.userAgent.indexOf( 'MSIE' ) || 0 <= navigator.userAgent.indexOf( 'Trident' ) ) {
			$( '.ie-warning' ).show();
		}

		if ( 0 <= navigator.userAgent.indexOf( 'Edge' ) ) {
			$( '.edge-warning' ).show();
		}

		if ( 0 === wpmdb_data.valid_licence ) {
			$( '#savefile' ).prop( 'checked', true );
		}
		var max_request_size_container = $( '.max-request-size' );
		var max_request_size_slider = $( '.slider', max_request_size_container );
		max_request_size_slider.slider( {
			range: 'min',
			value: parseInt( wpmdb_data.max_request / 1024 ),
			min: 512,
			max: parseInt( wpmdb_data.bottleneck / 1024 ),
			step: 256,
			create: function( event, ui ) {
				var display_info = globals.get_max_request_display_info( wpmdb_data.max_request / 1024 );
				globals.set_slider_value( max_request_size_container, wpmdb_data.max_request / 1024, display_info.unit, display_info.amount );
			},
			slide: function( event, ui ) {
				var display_info = globals.get_max_request_display_info( ui.value );
				globals.set_slider_value( max_request_size_container, ui.value, display_info.unit, display_info.amount );
			},
			stop: function( event, ui ) {
				$( '.slider-success-msg' ).remove();
				$( '.amount', max_request_size_container ).after( '<img src="' + globals.spinner_url + '" alt="" class="slider-spinner general-spinner" />' );
				max_request_size_slider.slider( 'disable' );

				$.ajax( {
					url: ajaxurl,
					type: 'POST',
					cache: false,
					data: {
						action: 'wpmdb_update_max_request_size',
						max_request_size: parseInt( ui.value ),
						nonce: wpmdb_data.nonces.update_max_request_size
					},
					error: function( jqXHR, textStatus, errorThrown ) {
						max_request_size_slider.slider( 'enable' );
						$( '.slider-spinner', max_request_size_container ).remove();
						alert( wpmdb_strings.max_request_size_problem );
						var display_info = globals.get_max_request_display_info( wpmdb_data.max_request / 1024 );
						globals.set_slider_value( max_request_size_container, wpmdb_data.max_request / 1024, display_info.unit, display_info.amount );
						max_request_size_slider.slider( 'enable' );
					},
					success: function() {
						max_request_size_slider.slider( 'enable' );
						$( '.slider-label-wrapper', max_request_size_container ).append( '<span class="slider-success-msg">' + wpmdb_strings.saved + '</span>' );
						$( '.slider-success-msg', max_request_size_container ).fadeOut( 2000, function() {
							$( this ).remove();
						} );
						$( '.slider-spinner', max_request_size_container ).remove();
					}
				} );
			}
		} );

		var delay_between_requests_container = $( '.delay-between-requests' );
		var delay_between_requests_slider = $( '.slider', delay_between_requests_container );
		delay_between_requests_slider.slider( {
			range: 'min',
			value: parseInt( wpmdb_data.delay_between_requests / 1000 ),
			min: 0,
			max: 10,
			step: 1,
			create: function( event, ui ) {
				globals.set_slider_value( delay_between_requests_container, wpmdb_data.delay_between_requests / 1000, 's' );
			},
			slide: function( event, ui ) {
				globals.set_slider_value( delay_between_requests_container, ui.value, 's' );
			},
			stop: function( event, ui ) {
				$( '.slider-success-msg' ).remove();
				$( '.amount', delay_between_requests_container ).after( '<img src="' + globals.spinner_url + '" alt="" class="slider-spinner general-spinner" />' );
				delay_between_requests_slider.slider( 'disable' );

				$.ajax( {
					url: ajaxurl,
					type: 'POST',
					cache: false,
					data: {
						action: 'wpmdb_update_delay_between_requests',
						delay_between_requests: parseInt( ui.value * 1000 ),
						nonce: wpmdb_data.nonces.update_delay_between_requests
					},
					error: function( jqXHR, textStatus, errorThrown ) {
						delay_between_requests_slider.slider( 'enable' );
						$( '.slider-spinner', delay_between_requests_container ).remove();
						alert( wpmdb_strings.delay_between_requests_problem );
						globals.set_slider_value( delay_between_requests_container, wpmdb_data.delay_between_requests / 1000, 's' );
						delay_between_requests_slider.slider( 'enable' );
					},
					success: function() {
						wpmdb_data.delay_between_requests = parseInt( ui.value * 1000 );
						delay_between_requests_slider.slider( 'enable' );
						$( '.slider-label-wrapper', delay_between_requests_container ).append( '<span class="slider-success-msg">' + wpmdb_strings.saved + '</span>' );
						$( '.slider-success-msg', delay_between_requests_container ).fadeOut( 2000, function() {
							$( this ).remove();
						} );
						$( '.slider-spinner', delay_between_requests_container ).remove();
					}
				} );
			}
		} );

		$( '.help-tab .video' ).each( function() {
			var $container = $( this ),
				$viewer = $( '.video-viewer' );

			$( 'a', this ).click( function( e ) {
				e.preventDefault();

				$viewer.attr( 'src', '//www.youtube.com/embed/' + $container.data( 'video-id' ) + '?autoplay=1' );
				$viewer.show();
				var offset = $viewer.offset();
				$( window ).scrollTop( offset.top - 50 );
			} );
		} );

		$( '.backup-options' ).show();
		$( '.keep-active-plugins' ).show();
		if ( 'savefile' === wpmdb.functions.wpmdb_migration_type() ) {
			$( '.backup-options' ).hide();
			$( '.keep-active-plugins' ).hide();
		}

		globals.last_replace_switch = wpmdb.functions.wpmdb_migration_type();

		/**
		 * Handle 'Check License Again' functionality found in expired license messages.
		 */
		$( '.content-tab' ).on( 'click', '.check-my-licence-again', function( e ) {
			e.preventDefault();
			globals.checked_licence = false;
			$( e.target ).replaceWith( 'Checking... ' + globals.ajax_spinner );
			globals.check_licence( null, 'all' );
		} );

		$.wpmdb.add_action( 'wpmdb_refresh_table_selects', globals.refresh_table_selects, '', globals );

		function update_push_table_select() {
			$( '#select-tables' ).remove();
			$( '.select-tables-wrap' ).prepend( globals.$push_select );
			$( '#select-tables' ).change();
		}

		$.wpmdb.add_action( 'wpmdb_update_push_table_select', update_push_table_select );

		function update_pull_table_select() {
			$( '#select-tables' ).remove();
			$( '.select-tables-wrap' ).prepend( globals.$pull_select );
			$( '#select-tables' ).change();
		}

		$.wpmdb.add_action( 'wpmdb_update_pull_table_select', update_pull_table_select );

		function disable_table_migration_options() {
			$( '#migrate-selected' ).parents( '.option-section' ).children( '.header-expand-collapse' ).children( '.expand-collapse-arrow' ).removeClass( 'collapsed' );
			$( '.table-select-wrap' ).show();
			$( '#migrate-only-with-prefix' ).prop( 'checked', false );
			$( '#migrate-selected' ).prop( 'checked', true );
			$( '.table-migrate-options' ).hide();
			$( '.select-tables-wrap' ).show();
		}

		$.wpmdb.add_action( 'wpmdb_disable_table_migration_options', disable_table_migration_options );

		function enable_table_migration_options() {
			$( '.table-migrate-options' ).show();
		}

		$.wpmdb.add_action( 'wpmdb_enable_table_migration_options', enable_table_migration_options );

		function select_all_tables() {
			$( '#select-tables' ).children( 'option' ).prop( 'selected', true );
			$( '#select-tables' ).change();
		}

		$.wpmdb.add_action( 'wpmdb_select_all_tables', select_all_tables );

		function base_old_url( value, args ) {
			return globals.remove_protocol( wpmdb_data.this_url );
		}

		$.wpmdb.add_filter( 'wpmdb_base_old_url', base_old_url );

		// automatically validate connection info if we're loading a saved profile
		globals.establish_remote_connection_from_saved_profile();

		// add to <a> tags which act as JS event buttons, will not jump page to top and will deselect the button
		$( 'body' ).on( 'click', '.js-action-link', function( e ) {
			e.preventDefault();
			$( this ).blur();
		} );

		$( '.licence-input' ).keypress( function( e ) {
			if ( 13 === e.which ) {
				e.preventDefault();
				$( '.register-licence' ).click();
			}
		} );

		// registers your licence
		$( 'body' ).on( 'click', '.register-licence', function( e ) {
			e.preventDefault();

			if ( globals.doing_licence_registration_ajax ) {
				return;
			}

			var licence_key = $.trim( $( '.licence-input' ).val() );
			var $licence_status = $( '.licence-status' );

			$licence_status.removeClass( 'notification-message error-notice success-notice' );

			if ( '' === licence_key ) {
				$licence_status.html( '<div class="notification-message error-notice">' + wpmdb_strings.enter_license_key + '</div>' );
				return;
			}

			$licence_status.empty().removeClass( 'success' );
			globals.doing_licence_registration_ajax = true;
			$( '.button.register-licence' ).after( '<img src="' + globals.spinner_url + '" alt="" class="register-licence-ajax-spinner general-spinner" />' );

			$.ajax( {
				url: ajaxurl,
				type: 'POST',
				dataType: 'JSON',
				cache: false,
				data: {
					action: 'wpmdb_activate_licence',
					licence_key: licence_key,
					nonce: wpmdb_data.nonces.activate_licence,
					context: 'licence'
				},
				error: function( jqXHR, textStatus, errorThrown ) {
					globals.doing_licence_registration_ajax = false;
					$( '.register-licence-ajax-spinner' ).remove();
					$licence_status.html( wpmdb_strings.register_license_problem );
				},
				success: function( data ) {
					$( '.register-licence-ajax-spinner' ).remove();

					if ( 'undefined' !== typeof data.errors ) {
						var msg = '';
						for ( var key in data.errors ) {
							msg += data.errors[ key ];
						}
						$licence_status.html( msg );

						if ( 'undefined' !== typeof data.masked_licence ) {
							globals.enable_pro_licence( data, licence_key );
							$( '.migrate-tab .invalid-licence' ).hide();
						}
					} else if ( 'undefined' !== typeof data.wpmdb_error && 'undefined' !== typeof data.body ) {
						$licence_status.html( data.body );
					} else {
						if ( 1 === Number( data.is_first_activation ) ) {
							wpmdb_strings.welcome_text = wpmdb_strings.welcome_text.replace( '%1$s', 'https://deliciousbrains.com/wp-migrate-db-pro/doc/quick-start-guide/?utm_campaign=support%2Bdocs&utm_source=MDB%2BPaid&utm_medium=insideplugin' );
							wpmdb_strings.welcome_text = wpmdb_strings.welcome_text.replace( '%2$s', 'https://deliciousbrains.com/wp-migrate-db-pro/videos/?utm_campaign=support%2Bdocs&utm_source=MDB%2BPaid&utm_medium=insideplugin' );

							$licence_status.after(
								'<div id="welcome-wrap">' +
								'<img id="welcome-img" src="' + wpmdb_data.this_plugin_url + 'asset/build/img/mdb-banner.svg" />' +
								'<div class="welcome-text">' +
								'<h3>' + wpmdb_strings.welcome_title + '</h3>' +
								'<p>' + wpmdb_strings.welcome_text + '</p>' +
								'</div>' +
								'</div>'
							);
						}

						$licence_status.html( wpmdb_strings.license_registered ).delay( 5000 ).fadeOut( 1000, function() {
							$( this ).css( { visibility: 'hidden', display: 'block' } ).slideUp();
						} );
						$licence_status.addClass( 'success notification-message success-notice' );
						globals.enable_pro_licence( data, licence_key );
						$( '.invalid-licence' ).hide();
					}

					globals.doing_licence_registration_ajax = false;
				}
			} );

		} );

		// clears the debug log
		$( '.clear-log' ).click( function() {
			$( '.ajax-spinner, .ajax-success-msg' ).remove();
			$( this ).after( globals.ajax_spinner );
			$( '.debug-log-textarea' ).val( '' );
			$.ajax( {
				url: ajaxurl,
				type: 'POST',
				dataType: 'text',
				cache: false,
				data: {
					action: 'wpmdb_clear_log',
					nonce: wpmdb_data.nonces.clear_log
				},
				error: function( jqXHR, textStatus, errorThrown ) {
					$( '.ajax-spinner' ).remove();
					alert( wpmdb_strings.clear_log_problem );
				},
				success: function( data ) {
					$( '.ajax-spinner, .ajax-success-msg' ).remove();
					globals.refresh_debug_log();
					$( '.clear-log' ).after( '<span class="ajax-success-msg">' + wpmdb_strings.clear_error_log + '</span>' );
					$( '.ajax-success-msg' ).fadeOut( 2000, function() {
						$( this ).remove();
					} );
				}
			} );
		} );

		// select all tables
		$( '.multiselect-select-all' ).click( function() {
			var multiselect = $( this ).parents( '.select-wrap' ).children( '.multiselect' );
			$( 'option', multiselect ).prop( 'selected', 1 );
			$( multiselect ).focus().trigger( 'change' );
		} );

		// deselect all tables
		$( '.multiselect-deselect-all' ).click( function() {
			var multiselect = $( this ).parents( '.select-wrap' ).children( '.multiselect' );
			$( 'option', multiselect ).removeAttr( 'selected' );
			$( multiselect ).focus().trigger( 'change' );
		} );

		// invert table selection
		$( '.multiselect-invert-selection' ).click( function() {
			var multiselect = $( this ).parents( '.select-wrap' ).children( '.multiselect' );
			$( 'option', multiselect ).each( function() {
				$( this ).attr( 'selected', !$( this ).attr( 'selected' ) );
			} );
			$( multiselect ).focus().trigger( 'change' );
		} );

		// on option select hide all "advanced" option divs and show the correct div for the option selected
		$( '.option-group input[type=radio]' ).change( function() {
			var group = $( this ).closest( '.option-group' );
			$( 'ul', group ).hide();
			var parent = $( this ).closest( 'li' );
			$( 'ul', parent ).show();
		} );

		// on page load, expand hidden divs for selected options (browser form cache)
		$( '.option-group' ).each( function() {
			$( '.option-group input[type=radio]' ).each( function() {
				if ( $( this ).is( ':checked' ) ) {
					var parent = $( this ).closest( 'li' );
					$( 'ul', parent ).show();
				}
			} );
		} );

		// expand and collapse content on click
		$( '.header-expand-collapse' ).click( function() {
			var target = null;

			if ( undefined !== $( this ).data( 'next' ) ) {
				target = $( this ).data( 'next' );
			}

			if ( $( '.expand-collapse-arrow', this ).hasClass( 'collapsed' ) ) {
				$( '.expand-collapse-arrow', this ).removeClass( 'collapsed' );
				if ( target ) {
					$( target ).show();
				} else {
					$( this ).next().show();
				}
			} else {
				$( '.expand-collapse-arrow', this ).addClass( 'collapsed' );
				if ( target ) {
					$( target ).hide();
				} else {
					$( this ).next().hide();
				}
			}
		} );

		$( '.checkbox-label input[type=checkbox]' ).change( function() {
			if ( $( this ).is( ':checked' ) ) {
				$( this ).parent().next().show();
			} else {
				$( this ).parent().next().hide();
			}
		} );

		// warning for excluding post types
		$( '.select-post-types-wrap' ).on( 'change', '#select-post-types', function() {
			wpmdb.functions.exclude_post_types_warning();
		} );

		if ( $( '#exclude-post-types' ).is( ':checked' ) ) {
			if ( $( '#select-post-types' ).val() ) {
				$( '.exclude-post-types-warning' ).css( { display: 'block', opacity: 1 } );
			}
		}

		// special expand and collapse content on click for save migration profile
		$( '#save-migration-profile' ).change( function() {
			wpmdb.functions.update_migrate_button_text();
			if ( $( this ).is( ':checked' ) ) {
				$( '.save-settings-button' ).show();
			} else {
				$( '.save-settings-button' ).hide();
			}
		} );

		if ( $( '#save-migration-profile' ).is( ':checked' ) ) {
			$( '.save-settings-button' ).show();
		}

		$( '.create-new-profile' ).focus( function() {
			$( '#create_new' ).prop( 'checked', true );
		} );

		$( '.checkbox-label input[type=checkbox]' ).each( function() {
			if ( $( this ).is( ':checked' ) ) {
				$( this ).parent().next().show();
			}
		} );

		// AJAX migrate button
		$( '.migrate-db-button' ).click( function( event ) {
			$( this ).blur();

			event.preventDefault();
			wpmdb.migration_state_id = '';

			if ( false === $.wpmdb.apply_filters( 'wpmdb_migration_profile_ready', true ) ) {
				return;
			}

			if ( true === wpmdb.functions.maybe_show_select_table_notice() ) {
				return;
			}

			var new_url_missing = false;
			var new_file_path_missing = false;
			if ( $( '#new-url' ).length && !$( '#new-url' ).val() ) {
				$( '#new-url-missing-warning' ).show();
				$( '#new-url' ).focus();
				$( 'html,body' ).scrollTop( 0 );
				new_url_missing = true;
			}

			if ( $( '#new-path' ).length && !$( '#new-path' ).val() ) {
				$( '#new-path-missing-warning' ).show();
				if ( false === new_url_missing ) {
					$( '#new-path' ).focus();
					$( 'html,body' ).scrollTop( 0 );
				}
				new_file_path_missing = true;
			}

			if ( true === new_url_missing || true === new_file_path_missing ) {
				if ( 'import' === wpmdb.functions.wpmdb_migration_type() ) {
					if ( $( '#import-find-replace' ).is( ':checked' ) ) {
						return;
					}
				} else {
					return;
				}
			}

			// also save profile
			if ( $( '#save-migration-profile' ).is( ':checked' ) ) {
				globals.save_active_profile();
			}

			globals.form_data = $( $( '#migrate-form' )[ 0 ].elements ).not( '.auth-credentials' ).serialize();

			globals.migration_intent = wpmdb.functions.wpmdb_migration_type();

			globals.stage = 'backup';

			if ( 'savefile' === globals.migration_intent ) {
				globals.stage = 'migrate';
			}

			if ( false === $( '#create-backup' ).is( ':checked' ) ) {
				if ( -1 !== $.inArray( globals.migration_intent, [ 'savefile', 'push', 'pull' ] ) ) {
					globals.stage = 'migrate';
				} else if ( 'import' === globals.migration_intent ) {
					globals.stage = 'upload';
				} else {
					globals.stage = globals.migration_intent;
				}
			}

			wpmdb.current_migration = wpmdb.migration_progress_controller.newMigration( {
				localTableSizes: wpmdb_data.this_table_sizes,
				localTableRows: wpmdb_data.this_table_rows,
				remoteTableSizes: 'undefined' !== typeof wpmdb.common.connection_data ? wpmdb.common.connection_data.table_sizes : null,
				remoteTableRows: 'undefined' !== typeof wpmdb.common.connection_data ? wpmdb.common.connection_data.table_rows : null,
				migrationIntent: wpmdb.functions.wpmdb_migration_type()
			} );

			var backup_option = $( 'input[name=backup_option]:checked' ).val();
			var table_option = $( 'input[name=table_migrate_option]:checked' ).val();
			var selected_tables = '';
			var data_type = '';

			// set up backup stage
			if ( 'backup' === globals.stage ) {
				if ( 'migrate_only_with_prefix' === table_option && 'backup_selected' === backup_option && 'import' !== globals.migration_intent ) {
					backup_option = 'backup_only_with_prefix';
				}
				if ( 'push' === globals.migration_intent ) {
					data_type = 'remote';
					if ( 'backup_only_with_prefix' === backup_option ) {
						globals.tables_to_migrate = wpmdb.common.connection_data.prefixed_tables;
					} else if ( 'backup_selected' === backup_option ) {
						selected_tables = $( '#select-tables' ).val();
						selected_tables = $.wpmdb.apply_filters( 'wpmdb_backup_selected_tables', selected_tables );
						globals.tables_to_migrate = globals.get_intersect( selected_tables, wpmdb.common.connection_data.tables );
					} else if ( 'backup_manual_select' === backup_option ) {
						globals.tables_to_migrate = $( '#select-backup' ).val();
					}
				} else {
					data_type = 'local';
					if ( 'backup_only_with_prefix' === backup_option ) {
						globals.tables_to_migrate = wpmdb_data.this_prefixed_tables;
					} else if ( 'backup_selected' === backup_option ) {
						selected_tables = $( '#select-tables' ).val();
						selected_tables = $.wpmdb.apply_filters( 'wpmdb_backup_selected_tables', selected_tables );
						globals.tables_to_migrate = globals.get_intersect( selected_tables, wpmdb_data.this_tables );
					} else if ( 'backup_manual_select' === backup_option ) {
						globals.tables_to_migrate = $( '#select-backup' ).val();
					}
				}

				wpmdb.current_migration.model.addStage( 'backup', globals.tables_to_migrate, data_type, {
					strings: {
						migrated: wpmdb_strings.backed_up
					}
				} );
			}

			// set up migration stage
			if ( 'pull' === globals.migration_intent ) {
				data_type = 'remote';
			} else {
				data_type = 'local';
			}

			if ( 'find_replace' === globals.migration_intent ) {
				wpmdb.current_migration.model.addStage( 'find_replace', wpmdb.functions.get_tables_to_migrate( null, null ), data_type, {
					strings: {
						migrated: wpmdb_strings.searched,
						stage_title: wpmdb_strings.migrate_button_find_replace
					}
				} );
			} else if ( -1 !== $.inArray( globals.migration_intent, [ 'savefile', 'push', 'pull' ] ) ) {
				wpmdb.current_migration.model.addStage( 'migrate', wpmdb.functions.get_tables_to_migrate( null, null ), data_type );
			}

			// add any additional migration stages via hook
			$.wpmdb.do_action( 'wpmdb_add_migration_stages', {
				data_type: data_type,
				tables_to_migrate: wpmdb.functions.get_tables_to_migrate( null, null )
			} );

			var table_intent = $( 'input[name=table_migrate_option]:checked' ).val();
			var connection_info = $.trim( $( '.pull-push-connection-info' ).val() ).split( '\n' );
			var table_rows = '';

			globals.remote_site = connection_info[ 0 ];
			globals.secret_key = connection_info[ 1 ];

			var static_migration_label = globals.get_migration_status_label( globals.remote_site, globals.migration_intent, 'migrating' );
			globals.completed_msg = globals.get_migration_status_label( globals.remote_site, globals.migration_intent, 'completed' );

			if ( -1 !== $.inArray( globals.stage, [ 'find_replace', 'backup', 'migrate' ] ) ) {
				globals.tables_to_migrate = wpmdb.current_migration.model.getStageItems( globals.stage, 'name' );
			}

			wpmdb.current_migration.model.setActiveStage( globals.stage );

			wpmdb.current_migration.setTitle( static_migration_label );

			wpmdb.current_migration.startTimer();

			globals.currently_migrating = true;
			wpmdb.current_migration.setStatus( 'active' );

			var request_data = {
				action: 'wpmdb_initiate_migration',
				intent: globals.migration_intent,
				url: globals.remote_site,
				key: globals.secret_key,
				form_data: globals.form_data,
				stage: globals.stage,
				nonce: wpmdb_data.nonces.initiate_migration
			};

			request_data.site_details = {
				local: wpmdb_data.site_details
			};

			if ( -1 !== $.inArray( globals.migration_intent, [ 'push', 'pull' ] ) ) {
				request_data.temp_prefix = wpmdb.common.connection_data.temp_prefix;
				request_data.site_details.remote = wpmdb.common.connection_data.site_details;
			}

			// site_details can have a very large number of elements that blows out PHP's max_input_vars
			// so we reduce it down to one variable for this one POST.
			request_data.site_details = JSON.stringify( request_data.site_details );

			request_data = $.wpmdb.apply_filters( 'wpmdb_initiate_migration_request_data', request_data, request_data );

			globals.doing_ajax = true;

			$.ajax( {
				url: ajaxurl,
				type: 'POST',
				dataType: 'json',
				cache: false,
				data: request_data,
				error: function( jqXHR, textStatus, errorThrown ) {

					wpmdb.current_migration.setState( wpmdb_strings.migration_failed, globals.get_ajax_errors( jqXHR.responseText, '(#112)', jqXHR ), 'error' );

					console.log( jqXHR );
					console.log( textStatus );
					console.log( errorThrown );
					globals.doing_ajax = false;
					wpmdb.common.migration_error = true;
					wpmdb.functions.migration_complete_events();

				},
				success: function( data ) {
					globals.doing_ajax = false;
					if ( 'undefined' !== typeof data && 'undefined' !== typeof data.wpmdb_error && 1 === data.wpmdb_error ) {
						wpmdb.common.migration_error = true;
						wpmdb.functions.migration_complete_events();
						wpmdb.current_migration.setState( wpmdb_strings.migration_failed, data.body, 'error' );

						return;
					}

					wpmdb.migration_state_id = data.migration_state_id;

					var i = 0;

					// Set delay between requests - use max of local/remote values, 0 if doing export
					globals.delay_between_requests = 0;
					if ( 'savefile' !== globals.migration_intent && 'undefined' !== typeof wpmdb.common.connection_data && 'undefined' !== typeof wpmdb.common.connection_data.delay_between_requests || 'import' === globals.migration_intent ) {
						if ( 'import' === globals.migration_intent ) {
							globals.delay_between_requests = wpmdb_data.delay_between_requests;
						} else {
							globals.delay_between_requests = Math.max( parseInt( wpmdb_data.delay_between_requests ), parseInt( wpmdb.common.connection_data.delay_between_requests ) );
						}
					}

					if ( -1 !== $.inArray( globals.migration_intent, [ 'savefile', 'push', 'pull', 'find_replace' ] ) ) {
						wpmdb.common.next_step_in_migration = {
							fn: wpmdb.functions.migrate_table_recursive,
							args: [ '-1', '']
						};
						wpmdb.functions.execute_next_step();
					}

					$.wpmdb.do_action( 'wpmdb_migration_initiated', globals.stage );
				}

			} ); // end ajax

		} );

		globals.update_migrate_button_text();

		// close progress pop up once migration is completed
		$( 'body' ).on( 'click', '.close-progress-content-button', function( e ) {
			globals.hide_overlay();
			wpmdb.current_migration.restoreTitleElem();
			wpmdb.functions.maybe_reload_page();
		} );

		$( 'body' ).on( 'click', '#overlay', function( e ) {
			if ( true === globals.migration_completed && e.target === this ) {
				globals.hide_overlay();
				wpmdb.current_migration.restoreTitleElem();
				wpmdb.functions.maybe_reload_page();
			}
		} );

		// AJAX save button profile
		$( '.save-settings-button' ).click( function( event ) {
			event.preventDefault();
			if ( '' === $.trim( $( '.create-new-profile' ).val() ) && $( '#create_new' ).is( ':checked' ) ) {
				alert( wpmdb_strings.enter_name_for_profile );
				$( '.create-new-profile' ).focus();
				return;
			}
			globals.save_active_profile();
		} );

		// move around textarea depending on whether or not the push/pull options are selected
		globals.move_connection_info_box();

		$( '.migrate-selection.option-group input[type=radio]' ).change( function() {
			globals.move_connection_info_box();
			wpmdb.migration_selection = wpmdb.functions.wpmdb_migration_type();
			if ( globals.connection_established ) {
				globals.change_replace_values();
			}
			wpmdb.functions.update_migrate_button_text();
		} );

		// hide second section if pull or push is selected with no connection established
		if ( ( 'pull' === wpmdb.functions.wpmdb_migration_type() || 'push' === wpmdb.functions.wpmdb_migration_type() ) && !globals.connection_established ) {
			$( '.step-two' ).hide();
			$( '.connection-status' ).show();
		}

		// show / hide GUID helper description
		$( '.general-helper' ).click( function( e ) {
			e.preventDefault();
			var icon = $( this ),
				bubble = $( this ).next();

			// Close any that are already open
			$( '.helper-message' ).not( bubble ).hide();

			var position = icon.position();
			if ( bubble.hasClass( 'bottom' ) ) {
				var bubble_offset = 1;

				if ( true === bubble.hasClass( 'compatibility-help' ) ) {
					bubble_offset = 6;
				} else if ( $( this ).is( ':first-child' ) ) {
					bubble_offset = 3;
				}
				bubble.css( {
					left: ( ( position.left - bubble.width() / 2 ) - bubble_offset ) + 'px',
					top: ( position.top + icon.height() + 9 ) + 'px'
				} );
			} else {
				bubble.css( {
					left: ( position.left + icon.width() + 9 ) + 'px',
					top: ( position.top + icon.height() / 2 - 18 ) + 'px'
				} );
			}
			bubble.toggle();
			e.stopPropagation();
		} );

		$( 'body' ).click( function() {
			$( '.helper-message' ).hide();
		} );

		$( '.helper-message' ).click( function( e ) {
			e.stopPropagation();
		} );

		$( 'body' ).on( 'click', '.show-errors-toggle', function( e ) {
			e.preventDefault();
			$( this ).next( '.migration-php-errors' ).toggle();
		} );

		// migrate / settings tabs
		$( '.nav-tab' ).click( function() {
			var hash = $( this ).attr( 'data-div-name' );
			hash = hash.replace( '-tab', '' );
			window.location.hash = hash;
			globals.switch_to_plugin_tab( hash, false );
		} );

		$( 'body' ).on( 'click', 'a[href^="#"]', function( event ) {
			var href = $( event.target ).attr( 'href' );
			var tab_name = href.substr( 1 );

			if ( tab_name ) {
				var nav_tab = $( '.' + tab_name );
				if ( 1 === nav_tab.length ) {
					nav_tab.trigger( 'click' );
					event.preventDefault();
				}
			}
		} );

		// repeatable fields
		$( 'body' ).on( 'click', '.add-row', function() {
			var $parent_tr = $( this ).parents( 'tr' );
			$parent_tr.before( $( '.original-repeatable-field' ).clone().removeClass( 'original-repeatable-field' ) );
			$parent_tr.prev().find( '.old-replace-col input' ).focus();
		} );

		// repeatable fields
		$( 'body' ).on( 'click', '.replace-remove-row', function() {
			$( this ).parents( 'tr' ).remove();
			if ( 2 >= $( '.replace-row' ).length ) {
				$( '.no-replaces-message' ).show();
			}

			var prev_id = $( this ).prev().attr( 'id' );
			if ( 'new-url' === prev_id || 'new-path' === prev_id ) {
				$( '#' + prev_id + '-missing-warning' ).hide();
			}
		} );

		// Hide New URL & New Path Warnings on change.
		$( 'body' )
			.on( 'change', '#new-url', function() {
				$( '#new-url-missing-warning' ).hide();
			} )
			.on( 'change', '#new-path', function() {
				$( '#new-path-missing-warning' ).hide();
			} );

		// Copy Find field to associated Replace field on arrow click.
		$( 'body' ).on( 'click', '.arrow-col', function() {
			var replace_row_arrow = this;

			if ( $( replace_row_arrow ).hasClass( 'disabled' ) ) {
				return;
			}

			var original_value = $( replace_row_arrow ).prev( 'td' ).find( 'input' ).val();
			var new_value_input = $( replace_row_arrow ).next( 'td' ).find( 'input' );
			new_value_input.val( original_value );

			// Hide New URL or New Path Warning if changed.
			if ( 'new-url' === new_value_input.prop( 'id' ) ) {
				$( '#new-url-missing-warning' ).hide();
			} else if ( 'new-path' === new_value_input.prop( 'id' ) ) {
				$( '#new-path-missing-warning' ).hide();
			}
		} );

		$( '.add-replace' ).click( function() {
			$( '.replace-fields' ).prepend( $( '.original-repeatable-field' ).clone().removeClass( 'original-repeatable-field' ) );
			$( '.no-replaces-message' ).hide();
		} );

		$( '#find-and-replace-sort tbody' ).sortable( {
			items: '> tr:not(.pin)',
			handle: 'td:first',
			start: function() {
				$( '.sort-handle' ).css( 'cursor', '-webkit-grabbing' );
				$( '.sort-handle' ).css( 'cursor', '-moz-grabbing' );
			},
			stop: function() {
				$( '.sort-handle' ).css( 'cursor', '-webkit-grab' );
				$( '.sort-handle' ).css( 'cursor', '-moz-grab' );
			}
		} );

		var hash = '';

		// check for hash in url (settings || migrate) switch tabs accordingly
		if ( window.location.hash ) {
			hash = window.location.hash.substring( 1 );
			globals.switch_to_plugin_tab( hash, false );
		}

		if ( '' !== globals.get_query_var( 'install-plugin' ) ) {
			hash = 'addons';
			globals.checked_licence = true;
			globals.switch_to_plugin_tab( hash, true );
		}

		// process notice links clicks, eg. dismiss, reminder
		$( '.notice-link' ).click( function( e ) {
			e.preventDefault();

			// process notice links clicks, eg. dismiss, reminder
			wpmdb.functions.ajax_handle_dismissible_notice( wpmdb_data.nonces.process_notice_link, function( ele ) {
				$( ele ).closest( '.inline-message' ).hide();
			}, $( this ) );
		} );

		// When read-only connection info is copied, convert it to one line
		$( '#connection_info' ).on( 'copy', function( e ) {
			var $this = $( this );

			// Test for two lines
			var lines = $this.val().split( '\n' );
			if ( 2 === lines.length ) {

				// Wrapping in a try in case there's no browser support
				try {

					// Combine the two lines into one
					e.originalEvent.clipboardData.setData( 'text/plain', lines.join( ' ' ) );
					e.preventDefault(); // Default behaviour is to copy any selected text
				}
				catch ( err ) {

					// Do nothing. Allow normal copying
				}
			}
		} );

		// regenerates the saved secret key
		$( '.reset-api-key' ).click( function() {
			var answer = confirm( wpmdb_strings.reset_api_key );

			if ( !answer || globals.doing_reset_api_key_ajax ) {
				return;
			}

			globals.doing_reset_api_key_ajax = true;
			$( '.reset-api-key' ).after( '<img src="' + globals.spinner_url + '" alt="" class="reset-api-key-ajax-spinner general-spinner" />' );

			$.ajax( {
				url: ajaxurl,
				type: 'POST',
				dataType: 'text',
				cache: false,
				data: {
					action: 'wpmdb_reset_api_key',
					nonce: wpmdb_data.nonces.reset_api_key
				},
				error: function( jqXHR, textStatus, errorThrown ) {
					alert( wpmdb_strings.reset_api_key_problem );
					$( '.reset-api-key-ajax-spinner' ).remove();
					globals.doing_reset_api_key_ajax = false;
				},
				success: function( data ) {
					$( '.reset-api-key-ajax-spinner' ).remove();
					globals.doing_reset_api_key_ajax = false;
					$( '.connection-info' ).val( data );
					wpmdb_data.connection_info = $.trim( data ).split( '\n' );
				}
			} );

		} );

		// Copy the connection info to the clipboard
		$( '.copy-api-key' ).click( function() {

			var $el = $( this );

			// Get connection_info input
			var $connection_info = $( '#connection_info' );

			// Get the connection info
			var two_lines = $connection_info.val();

			// Make it one line, if it's two
			var one_line = two_lines.replace( '\n', ' ' );

			// Replace two lines with one
			$connection_info.val( one_line );

			// Select the input val
			$connection_info.select();

			try {

				// Copy connection_info
				document.execCommand( 'copy' );

				// Unselect connection_info input
				$connection_info.blur();

				// show confirmation
				$el.css( 'color', 'transparent' );
				var $confirmation = $( '.copy-api-key-confirmation' ).show();

				// fadeout confirmation
				setTimeout( function() {
					$confirmation.fadeOut( 'fast' );
					setTimeout( function() {
						$el.css( 'color', '' );
					}, 200 );

				}, 1000 );
			}
			catch ( err ) {
				alert( 'please press Ctrl/Cmd+C to copy' );
			}

			// Replace the input val with the two lines
			$connection_info.val( two_lines );
		} );

		$( 'input[name=table_migrate_option]' ).change( function() {
			$( '.select-tables-wrap' ).hide();

			if ( 'migrate_select' === $( this ).val() ) {
				$( '.select-tables-wrap' ).show();
			}
		} );

		$( '.show-multiselect' ).each( function() {
			if ( $( this ).is( ':checked' ) ) {
				$( this ).parents( '.option-section' ).children( '.header-expand-collapse' ).children( '.expand-collapse-arrow' ).removeClass( 'collapsed' );
				$( this ).parents( '.expandable-content' ).show();
				$( this ).parents( '.expandable-content' ).children( '.select-wrap' ).toggle();
			}
		} );

		$( 'input[name=backup_option]' ).change( function() {
			$( '.backup-tables-wrap' ).hide();
			if ( 'backup_manual_select' === $( this ).val() ) {
				$( '.backup-tables-wrap' ).show();
			}
		} );

		if ( $( '#backup-manual-select' ).is( ':checked' ) ) {
			$( '.backup-tables-wrap' ).show();
		}

		$( '.plugin-compatibility-save' ).click( function() {
			if ( globals.doing_plugin_compatibility_ajax ) {
				return;
			}
			$( this ).addClass( 'disabled' );
			var select_element = $( '#selected-plugins' );
			$( select_element ).attr( 'disabled', 'disabled' );

			$( '.plugin-compatibility-success-msg' ).remove();

			globals.doing_plugin_compatibility_ajax = true;
			$( this ).after( '<img src="' + globals.spinner_url + '" alt="" class="plugin-compatibility-spinner general-spinner" />' );

			$.ajax( {
				url: ajaxurl,
				type: 'POST',
				dataType: 'text',
				cache: false,
				data: {
					action: 'wpmdb_whitelist_plugins',
					whitelist_plugins: $( select_element ).val(),
					nonce: wpmdb_data.nonces.whitelist_plugins
				},
				error: function( jqXHR, textStatus, errorThrown ) {
					alert( wpmdb_strings.blacklist_problem + '\r\n\r\n' + wpmdb_strings.status + ' ' + jqXHR.status + ' ' + jqXHR.statusText + '\r\n\r\n' + wpmdb_strings.response + '\r\n' + jqXHR.responseText );
					$( select_element ).removeAttr( 'disabled' );
					$( '.plugin-compatibility-save' ).removeClass( 'disabled' );
					globals.doing_plugin_compatibility_ajax = false;
					$( '.plugin-compatibility-spinner' ).remove();
				},
				success: function( data ) {
					if ( '' !== $.trim( data ) ) {
						alert( data );
					}
					$( select_element ).removeAttr( 'disabled' );
					$( '.plugin-compatibility-save' ).removeClass( 'disabled' );
					globals.doing_plugin_compatibility_ajax = false;
					$( '.plugin-compatibility-spinner' ).remove();
					$( '.plugin-compatibility-save' ).after( '<span class="plugin-compatibility-success-msg">' + wpmdb_strings.saved + '</span>' );
					$( '.plugin-compatibility-success-msg' ).fadeOut( 2000 );
				}
			} );
		} );

		// delete a profile from the migrate form area
		$( 'body' ).on( 'click', '.delete-profile', function() {
			var name = $( this ).next().clone();
			$( 'input', name ).remove();
			name = $.trim( $( name ).html() );
			var answer = confirm( wpmdb_strings.remove_profile.replace( '{{profile}}', name ) );

			if ( !answer ) {
				return;
			}
			var $profile_li = $( this ).parent();

			if ( $profile_li.find( 'input:checked' ).length ) {
				var $new_profile_li = $profile_li.siblings().last();
				$new_profile_li.find( 'input[type=radio]' ).prop( 'checked', 'checked' );
				$new_profile_li.find( 'input[type=text]' ).focus();
				$( '#migrate-form .crumbs .crumb:last' ).text( 'New Profile' );

				if ( 'function' === typeof window.history.pushState ) {
					var updated_url = window.location.href.replace( '#migrate', '' ).replace( /&wpmdb-profile=-?\d+/, '' ) + '&wpmdb-profile=-1';
					window.history.pushState( { updated_profile_id: -1 }, null, updated_url );
				}
			}

			$profile_li.fadeOut( 500 );

			$.ajax( {
				url: ajaxurl,
				type: 'POST',
				dataType: 'text',
				cache: false,
				data: {
					action: 'wpmdb_delete_migration_profile',
					profile_id: $( this ).attr( 'data-profile-id' ),
					nonce: wpmdb_data.nonces.delete_migration_profile
				},
				error: function( jqXHR, textStatus, errorThrown ) {
					alert( wpmdb_strings.remove_profile_problem );
				},
				success: function( data ) {
					if ( '-1' === data ) {
						alert( wpmdb_strings.remove_profile_not_found );
					}
				}
			} );

		} );

		// deletes a profile from the main profile selection screen
		$( '.main-list-delete-profile-link' ).click( function() {
			var name = $( this ).prev().html();
			var answer = confirm( wpmdb_strings.remove_profile.replace( '{{profile}}', name ) );

			if ( !answer ) {
				return;
			}

			$( this ).parent().fadeOut( 500 );

			$.ajax( {
				url: ajaxurl,
				type: 'POST',
				dataType: 'text',
				cache: false,
				data: {
					action: 'wpmdb_delete_migration_profile',
					profile_id: $( this ).attr( 'data-profile-id' ),
					nonce: wpmdb_data.nonces.delete_migration_profile
				},
				error: function( jqXHR, textStatus, errorThrown ) {
					alert( wpmdb_strings.remove_profile_problem );
				}
			} );

		} );

		// warn the user when editing the connection info after a connection has been established
		$( 'body' ).on( 'click', '.temp-disabled', function() {
			var answer = confirm( wpmdb_strings.change_connection_info );

			if ( answer ) {
				$( '.ssl-notice' ).hide();
				$( '.different-plugin-version-notice' ).hide();
				$( '.migrate-db-button' ).show();
				$( '.temp-disabled' ).removeAttr( 'readonly' );
				$( '.temp-disabled' ).removeClass( 'temp-disabled' );
				$( '.connect-button' ).show();
				$( '.step-two' ).hide();
				$( '.connection-status' ).show().html( wpmdb_strings.enter_connection_info );
				globals.connection_established = false;
			}
		} );

		// ajax request for settings page when checking/unchecking setting radio buttons
		$( '.settings-tab input[type=checkbox]' ).change( function() {
			if ( 'plugin-compatibility' === $( this ).attr( 'id' ) ) {
				return;
			}
			var checked = $( this ).is( ':checked' );
			var setting = $( this ).attr( 'id' );
			var $status = $( this ).closest( 'td' ).next( 'td' ).find( '.setting-status' );

			//Usge tracking setting
			if ( 'allow_tracking' === $( this ).attr( 'id' ) ) {
				wpmdb_data.allow_tracking = checked ? '1' : '';
			}

			$( '.ajax-success-msg' ).remove();
			$status.after( globals.ajax_spinner );

			$.ajax( {
				url: ajaxurl,
				type: 'POST',
				dataType: 'text',
				cache: false,
				data: {
					action: 'wpmdb_save_setting',
					checked: checked,
					setting: setting,
					nonce: wpmdb_data.nonces.save_setting
				},
				error: function( jqXHR, textStatus, errorThrown ) {
					alert( wpmdb_strings.save_settings_problem );
					$( '.ajax-spinner' ).remove();
				},
				success: function( data ) {
					$( '.ajax-spinner' ).remove();
					$status.append( '<span class="ajax-success-msg">' + wpmdb_strings.saved + '</span>' );
					$( '.ajax-success-msg' ).fadeOut( 2000, function() {
						$( this ).remove();
					} );
				}
			} );

		} );

		// disable form submissions
		$( '.migrate-form' ).submit( function( e ) {
			e.preventDefault();
		} );

		// fire connection_box_changed when the connect button is pressed
		$( '.connect-button' ).click( function( event ) {
			event.preventDefault();
			$( this ).blur();
			wpmdb.functions.connection_box_changed();
		} );

		// send paste even to connection_box_changed() function
		$( '.pull-push-connection-info' ).bind( 'paste', function( e ) {
			var $this = this;
			setTimeout( function() {
				wpmdb.functions.connection_box_changed();
			}, 0 );

		} );

		$( 'body' ).on( 'click', '.try-again', function() {
			$( '.pull-push-connection-info' ).removeClass( 'temp-disabled' );
			wpmdb.functions.connection_box_changed();
		} );

		$( 'body' ).on( 'click', '.try-http', function() {
			var connection_info = $.trim( $( '.pull-push-connection-info' ).val() ).split( '\n' );
			var new_url = connection_info[ 0 ].replace( 'https', 'http' );
			var new_contents = new_url + '\n' + connection_info[ 1 ];
			$( '.pull-push-connection-info' ).val( new_contents );
			wpmdb.functions.connection_box_changed();
		} );

		$( '.create-new-profile' ).change( function() {
			globals.profile_name_edited = true;
		} );

		$( 'body' ).on( 'click', '.temporarily-disable-ssl', function() {
			var hash = '';
			if ( window.location.hash ) {
				hash = window.location.hash.substring( 1 );
			}
			$( this ).attr( 'href', $( this ).attr( 'href' ) + '&hash=' + hash );
		} );

		// Sets the initial Pause/Resume button event to Pause
		$( 'body' ).on( 'click', '.pause-resume', function( event ) {
			globals.set_pause_resume_button( event );
		} );

		$( 'body' ).on( 'click', '.cancel', function( event ) {
			globals.cancel_migration( event );
		} );

		$( '.enter-licence' ).click( function() {
			$( '.settings' ).click();
			$( '.licence-input' ).focus();
		} );

		$( 'body' ).on( 'click', '.copy-licence-to-remote-site', function() {
			$( '.connection-status' ).html( wpmdb_strings.copying_license );
			$( '.connection-status' ).removeClass( 'notification-message error-notice migration-error' );
			$( '.connection-status' ).append( globals.ajax_spinner );

			var connection_info = $.trim( $( '.pull-push-connection-info' ).val() ).split( '\n' );

			globals.doing_ajax = true;
			globals.disable_export_type_controls();

			$.ajax( {
				url: ajaxurl,
				type: 'POST',
				dataType: 'json',
				cache: false,
				data: {
					action: 'wpmdb_copy_licence_to_remote_site',
					url: connection_info[ 0 ],
					key: connection_info[ 1 ],
					nonce: wpmdb_data.nonces.copy_licence_to_remote_site
				},
				error: function( jqXHR, textStatus, errorThrown ) {
					$( '.connection-status' ).html( globals.get_ajax_errors( jqXHR.responseText, '(#143)', jqXHR ) );
					$( '.connection-status' ).addClass( 'notification-message error-notice migration-error' );
					$( '.ajax-spinner' ).remove();
					globals.doing_ajax = false;
					globals.enable_export_type_controls();
				},
				success: function( data ) {
					$( '.ajax-spinner' ).remove();
					globals.doing_ajax = false;
					globals.enable_export_type_controls();

					if ( 'undefined' !== typeof data.wpmdb_error && 1 === data.wpmdb_error ) {
						$( '.connection-status' ).html( data.body );
						$( '.connection-status' ).addClass( 'notification-message error-notice migration-error' );

						if ( data.body.indexOf( '401 Unauthorized' ) > -1 ) {
							$( '.basic-access-auth-wrapper' ).show();
						}

						return;
					}
					wpmdb.functions.connection_box_changed();
				}
			} );
		} );

		$( 'body' ).on( 'click', '.reactivate-licence', function( e ) {
			globals.doing_ajax = true;

			$( '.invalid-licence' ).empty().html( wpmdb_strings.attempting_to_activate_licence );
			$( '.invalid-licence' ).append( globals.ajax_spinner );

			$.ajax( {
				url: ajaxurl,
				type: 'POST',
				dataType: 'json',
				cache: false,
				data: {
					action: 'wpmdb_reactivate_licence',
					nonce: wpmdb_data.nonces.reactivate_licence
				},
				error: function( jqXHR, textStatus, errorThrown ) {
					$( '.invalid-licence' ).html( wpmdb_strings.activate_licence_problem );
					$( '.invalid-licence' ).append( '<br /><br />' + wpmdb_strings.status + ': ' + jqXHR.status + ' ' + jqXHR.statusText + '<br /><br />' + wpmdb_strings.response + '<br />' + jqXHR.responseText );
					$( '.ajax-spinner' ).remove();
					globals.doing_ajax = false;
				},
				success: function( data ) {
					$( '.ajax-spinner' ).remove();
					globals.doing_ajax = false;

					if ( 'undefined' !== typeof data.wpmdb_error && 1 === data.wpmdb_error ) {
						$( '.invalid-licence' ).html( data.body );
						return;
					}

					if ( 'undefined' !== typeof data.wpmdb_dbrains_api_down && 1 === data.wpmdb_dbrains_api_down ) {
						$( '.invalid-licence' ).html( wpmdb_strings.temporarily_activated_licence );
						$( '.invalid-licence' ).append( data.body );
						return;
					}

					$( '.invalid-licence' ).empty().html( wpmdb_strings.licence_reactivated );
					location.reload();
				}
			} );

		} );

		$( 'input[name=table_migrate_option]' ).change( function() {
			globals.maybe_show_mixed_cased_table_name_warning();
			$.wpmdb.do_action( 'wpmdb_tables_to_migrate_changed' );
		} );

		$( 'body' ).on( 'change', '#select-tables', function() {
			globals.maybe_show_mixed_cased_table_name_warning();
			$.wpmdb.do_action( 'wpmdb_tables_to_migrate_changed' );
		} );

		$.wpmdb.add_filter( 'wpmdb_get_table_prefix', globals.get_table_prefix );
		$.wpmdb.add_filter( 'wpmdb_get_tables_to_migrate', wpmdb.functions.get_tables_to_migrate );
		$.wpmdb.add_action( 'wpmdb_lock_replace_url', globals.lock_replace_url );
		$.wpmdb.add_action( 'wpmdb_pin_replace_url', globals.pin_replace_url );
		$.wpmdb.add_action( 'move_connection_info_box', wpmdb.functions.exclude_post_types_warning );

		$.wpmdb.add_filter( 'wpmdb_before_migration_complete_hooks', function( hooks ) {
			globals.pause_before_finalize = !!$( 'input[name=pause_before_finalize]:checked' ).length;
			if ( true === globals.pause_before_finalize && 'savefile' !== globals.migration_intent ) {
				globals.set_pause_resume_button( null ); // don't just set migration_paused to true, since `set_pause_resume_button` will get double bound to clicking resume
				window.is_auto_pause_before_finalize = true;
			}
			return hooks;
		} );

		$( '.wpmdb-switch' ).on( 'click', function( e ) {
			if ( !$( this ).hasClass( 'disabled' ) ) {
				globals.set_checkbox( $( this ).attr( 'id' ) );
			}
		} );

		$( '#beta_optin-wrap' ).on( 'click', function( e ) {
			var switch_on = $( this ).find( 'span.on' ).hasClass( 'checked' );
			if ( switch_on ) {
				return;
			}

			if ( !wpmdb_data.is_beta_plugins_installed ) {
				return;
			}

			var answer = confirm( wpmdb_strings.rollback_beta_to_stable );

			if ( !answer ) {
				return;
			}

			window.location = wpmdb_data.rollback_to_stable_url;
		} );

	} );
})( jQuery, wpmdb );



// WEBPACK FOOTER //
// ./src/wp-migrate-db-pro/asset/src/js/script.js